export enum WebcheckoutTypeEnum {
  EXPRESS_CHECKOUT = "expressCheckout",
}
